<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Container-->
<div class="MainMenu">
	<!--Header-->
	<div *ngIf="SectionScheduleDetailID == -1" class="HeaderCenter">
		<h4>Select a Section:</h4>
	</div>

	<!--Header-->
	<div *ngIf="SchoolClosed == true" class="HeaderCenter">
		<h4 style="color: red">School Closed on: {{ FormatDate(SelectDate) }}</h4>
	</div>

	<!-- <div *ngIf="SectionScheduleDetailID != -1 && IsError() == true" class="HeaderCenter">
        <h4>Error Message: {{lstClassAttendance[0].RET}}</h4>
    </div> -->

	<!--Table-->
	<div *ngIf="SectionScheduleDetailID != -1 && SchoolClosed == false" class="table-main-body">
		<p-table
			#mydt
			id="mydtable"
			[value]="lstClassAttendance"
			[loading]="loading"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="single"
			[(selection)]="SelectedClassAttendance"
			dataKey="StudentID"
			(onFilter)="onHandleFilter($event)"
			(onSort)="onHandleSort($event)"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<!--INSERT CUSTOM FILTERS HERE-->

					<!--ClassStatusDesc-->
					<th>
						<!-- <p-columnFilter field="ClassStatusDesc" matchMode="equals" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown #filterClassStatusDesc [ngModel]="value" [options]="lstClassStatusDesc" (onChange)="filter($event.value)"
                                    placeholder="Any" [showClear]="true">
                                    <ng-template let-value pTemplate="item">
                                        <span>{{value}}</span>
                                    </ng-template>
                                </p-dropdown>
                            </ng-template>
                        </p-columnFilter> -->
					</th>

					<!--ExcuseDesc-->
					<th>
						<!-- <p-columnFilter field="ExcuseDesc" matchMode="equals" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown #filterExcuseDesc [ngModel]="value" [options]="lstExcuseDesc" (onChange)="filter($event.value)"
                                    placeholder="Any" [showClear]="true">
                                    <ng-template let-value pTemplate="item">
                                        <span>{{value}}</span>
                                    </ng-template>
                                </p-dropdown>
                            </ng-template>
                        </p-columnFilter> -->
					</th>

					<!--SchoolStatusDesc-->
					<th>
						<!-- <p-columnFilter field="SchoolStatusDesc" matchMode="equals" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown #filterSchoolStatusDesc [ngModel]="value" [options]="lstSchoolStatusDesc" (onChange)="filter($event.value)"
                                    placeholder="Any" [showClear]="true">
                                    <ng-template let-value pTemplate="item">
                                        <span>{{value}}</span>
                                    </ng-template>
                                </p-dropdown>
                            </ng-template>
                        </p-columnFilter> -->
					</th>

					<!--StudentID-->
					<th>
						<p-columnFilter type="text" field="StudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--LastName-->
					<th>
						<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--FirstName-->
					<th>
						<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="ClassStatusID">Class Status<p-sortIcon field="ClassStatusID"></p-sortIcon></th>
					<th pSortableColumn="ExcuseID">Excuse<p-sortIcon field="ExcuseID"></p-sortIcon></th>
					<th pSortableColumn="SchoolStatusDesc">School Status<p-sortIcon field="SchoolStatusDesc"></p-sortIcon></th>
					<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
					<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
					<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-ClassAttendance>
				<tr [pSelectableRow]="ClassAttendance">
					<td>
						<select [disabled]="SchoolStatus == 'Closed'" class="form-control" [(ngModel)]="ClassAttendance.ClassStatusID">
							<option value="" style="display: none"></option>
							<option *ngFor="let o of AttendanceStatusList" [ngValue]="o.ClassAttendanceStatusID">
								{{ o.ClassAttendanceStatusDesc }}
							</option>
						</select>
					</td>
					<td>
						<select
							[disabled]="IsExcused(ClassAttendance.ClassStatusID, ClassAttendance) == false || SchoolStatus == 'Closed'"
							class="form-control"
							[(ngModel)]="ClassAttendance.ExcuseID"
						>
							<option value="" style="display: none"></option>
							<option *ngFor="let o of ExcuseList" [ngValue]="o.ExcuseID">
								{{ o.ExcuseDesc }}
							</option>
						</select>
					</td>
					<td
						[ngStyle]="{
							color: ClassAttendance.SchoolStatusDesc == 'School Open' ? 'black' : 'red'
						}"
						style="font-weight: bold"
					>
						{{ ClassAttendance["SchoolStatusDesc"] }}
					</td>

					<td *ngFor="let col of cols" style="font-weight: bold">
						{{ ClassAttendance[col.field] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>

	<!--Add or Edit? a class attendance entry-->
	<div *ngIf="SectionScheduleDetailID != -1 && SchoolClosed == false" class="Buttons">
		<button class="btn btn-primary" (click)="onAllPresent()">Mark All Present</button>
		<button class="btn btn-primary" (click)="onAllAbsent()">Mark All Absent</button>

		<button *ngIf="Mode == 'Add'" class="btn btn-primary" (click)="onAdd()">Add Class Attendance</button>
		<button *ngIf="Mode == 'Update'" class="btn btn-primary" (click)="onUpdate()">Update Class Attendance</button>
	</div>

	<!--Error Message-->
	<div class="TopMargin Message">
		<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
			{{ errorMessage }}
		</div>
	</div>
</div>
